(function () {
  const sectionName = 'gallery-with-text';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const iconsArray = document.querySelectorAll('.galleryText__itemListIcon--open');

    function toggleQuickView(target) {
      const currentList = target.closest('.galleryText__item').querySelector('.galleryText__itemList');

      currentList.classList.toggle('galleryText__itemList--active');
    }

    iconsArray.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleQuickView(e.currentTarget);
      });
    });
  }

  Shopify.theme.sections.register(sectionName);
}());
